module.exports = __webpack_public_path__ + "static/media/nightlight_c.54964557.tif";